import { useNavigate, useParams } from 'react-router';
import { useEffect, useState } from 'react';

import AppGetIcon from '../../../../common/UI/AppGetIcon';
import ProgressBar from '../../../../common/UI/ProgressBar';

import { GetPermissionService } from '../../services/admin/permissionRoles/getPermission.service';
import { CreateOrUpdatePermissionService } from '../../services/admin/permissionRoles/createOrUpdatePermission.service';

import style from './permissionRoles.module.css'
import styleDataTable from "../../../../common/UI/DataTable/dataTable.module.css";



import { useHeaderStore } from '../../../../store/header.store';
import { shallow } from 'zustand/shallow';
import AppButton from '../../../../common/UI/Buttons/AppButton';

export default function CPermissionRoles() {
  const paramsUrl = useParams();
  const navigate = useNavigate();
  const headerStore = useHeaderStore(
    (state) => ({
      setModule: state.setModule,
      setModuleItem: state.setModuleItem,
      setItemChildren: state.setItemChildren,
    }),
    shallow
  );

  const [loading, setLoading] = useState<boolean>(true);
  const [dataModules, setDataModules] = useState<any[]>([]);
  const [selectAll, setSelectAll] = useState(false);

  useEffect(() => {
    headerStore.setModule('Administración', '');
    headerStore.setModuleItem('Roles', '/admin/roles');
    headerStore.setItemChildren('Permisos', '');

    return (() => {
      headerStore.setItemChildren('', '');
    })
  }, []);
const fetchPermissions = async () => {
  try {
    setLoading(true);
    if (paramsUrl.roleId) {
      const data = await GetPermissionService(paramsUrl.roleId);
     const mappedData = data.map((item: any) => ({
      ...item,
      active: item.authorized === 1 || item.authorized === true // por si viene como 1 o boolean
    }));

      setDataModules(mappedData);
    }
  } catch (error) {
    console.error("Error fetching permissions:", error);
  } finally {
    setLoading(false);
  }
};

  useEffect(() => {
    fetchPermissions();
  }, [paramsUrl.roleId]);


  useEffect(() => {
    if (dataModules.length > 0) {
      const allSelected = dataModules.every(item => item.active);
      setSelectAll(allSelected);
    } else {
      setSelectAll(false);
    }
  }, [dataModules]);

  const updatePermission = async (updatedModules: any[]) => {
    try {
      if (paramsUrl.roleId) {
        const activeModules = updatedModules.filter((item: any) => item.active);
        const service = new CreateOrUpdatePermissionService(paramsUrl.roleId);
        await service.run(activeModules.map((item: any) => item.id));
        // 🔥 después de guardar, vuelve a cargar el listado desde el backend
        await fetchPermissions();
      }
    } catch (error) {
      console.error("Error updating permissions:", error);
    }
  };



  const toggleSelectAll = () => {
    const newValue = !selectAll;
    const updated = dataModules.map((item) => ({
      ...item,
      active: newValue
    }));
    setSelectAll(newValue);
    setDataModules(updated);
    updatePermission(updated); // enviará solo los activos
  };

  const togglePermission = (item: any) => {
    const updated = dataModules.map((mod) =>
      mod.name === item.name ? { ...mod, active: !mod.active } : mod
    );
    setDataModules(updated);
    updatePermission(updated); // enviará solo los activos
  };
  const handleBack = () => {
    navigate(`/adminUsers/roles`);
  };

  return (
    <div className={style.container_permissions}>
      <div className={style.header__title_table} style={{ fontWeight: 'bold' }}>
        <span style={{ fontWeight: 'bold', width: '100%' }}>
        {`Gestionar los permisos para el rol - ${paramsUrl.name ?? ''}`}

        </span>
      <AppButton
        className={styleDataTable.buttom_option}
        variant="primary"
        iconName='arrow-back'
        buttonText="Volver"
        onClick={handleBack}
        unsetWidth
      />
      </div>

      <br />

      <div className={style.permissions_body}>
        {loading && <ProgressBar width="calc(100% - 0px)" height="calc(100vh - 57px)" />}
        {!loading && (
          <table className={`${style.table} ${style.tableStriped}`}>
            <thead>
              <tr>
                <th>Código</th>
                <th>Descripción</th>
                <th>
                  Estado (Activo/Inactivo)  
                  <div style={{ display:'flex', alignItems:'center',gap:'0.2rem' }}>

                  <input type="checkbox" onChange={toggleSelectAll} checked={selectAll} />
                  <span style={{ marginLeft: '5px' }}>(Sel. todos)</span>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              {dataModules.map((item, index) => (
                <tr key={index}>
                  <td>{item.name}</td>
                  <td>{item.description}</td>
                  <td>
                    <input
                      type="checkbox"
                      checked={item.active}
                      onChange={() => togglePermission(item)}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
